module.exports = __webpack_public_path__ + "static/media/logo_200.56b6f165.png";